import { Transition, Dialog } from "@headlessui/react";
import React, { Fragment, useState } from "react";
import ReactTooltip from "react-tooltip";
import CancelButton from "../../../../../components/CancelButton";
import EditButton from "../../../../../components/EditButton";
import MultiSelectInput from "../../../../../components/MultiSelectInput";
import SaveButton from "../../../../../components/SaveButton";
import MaterialTableTS from "../../../../../components/tables/MaterialTableTS";
import TextInput from "../../../../../components/TextInput";
import { accountAtom } from "../../../../Login/atoms/AccountAtom";
import { useQueryClient } from "react-query";
import { useRecoilState, useRecoilValue } from "recoil";
import ConfirmBoxNoLabel from "../../../../../components/ConfirmBoxNoLabel";
import useAddRoleData from "../hooks/useAddRoleData";
import { toast } from "../../../../../components/toastNotification";

interface IUsers {
  accountId: number;
  createdBy?: string;
  createdDate?: string;
  emailAddress: string;
  employeeId?: number;
  employeeNumber: string;
  isActive: true | false;
  isConfie: true | false;
  isFranchise: true | false;
  roleId?: number;
  updatedBy?: string;
  updatedDate?: string;
}

interface RoleUsersViewModalProps {
  userData: IUsers[] | undefined;
}
const RoleUsersViewModal = ({
  roleName,
  isOpen,
  onClose,
  userData = [],
  handleMultiSelectUser,
  multiUser,
  userOptions,
  setRoleNameModal,
  setSelectedUserData,
  setShowUserModal,
  handleEdit,
  isForAddingRole = false,
  setAddRolePermissions,
}) => {
  const [isEditUser, setIsEditUser] = useState(false);
  const [roleData, setRoleData] = useState<any>([]);
  const queryClient = useQueryClient();
  const userAccount = useRecoilValue(accountAtom);
  const [saveModal, setSaveModal] = useState(false);
  const {
    mutate: AddRole,
    data: AddRes,
    isSuccess: addSuccess,
    isError: addError,
    reset: resetAdd,
  } = useAddRoleData();
  const agencyColumns = [
    {
      title: "Email Address",
      field: "emailAddress",
      render: (row) => {
        return isEditUser ? (
          <>
            <MultiSelectInput
              options={userOptions}
              value={multiUser}
              handleMultiSelect={(e) => {
                handleMultiSelectUser(e);
              }}
              defaultValue={userOptions?.filter((x) => x.value === x.accountId)}
            />
          </>
        ) : (
          <>
            <div className="italic text-gray-400 text-xs">
              {row.emailAddress}
            </div>
          </>
        );
      },
    },
  ];
  const handleSave = () => {
    AddRole(roleData);
  };
  const HandleCancel = () => {
    setSaveModal(false);
    setShowUserModal(false);
    setAddRolePermissions(false);
  };
  if (addSuccess && AddRes) {
    if (AddRes.status === 201 || AddRes.status === 200) {
      toast.fire("Success", "Role added successfully", "success");
      queryClient.invalidateQueries("GetRolesWithUsers");
      setRoleData([]);
      HandleCancel();
    } else if (AddRes.status === 500) {
      if (
        AddRes.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available" ||
        AddRes.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available"
      ) {
        toast.fire(
          "Warning",
          "Role were successfully added, but " + AddRes.data.message,
          "warning"
        );
        setRoleData([]);
      } else {
        toast.fire(
          "Adding of Role failed",
          "Server Error: Cannot add Role",
          "error"
        );
      }

      queryClient.invalidateQueries("GetRolesWithUsers");
    } else {
      toast.fire(
        "Adding of Role failed",
        "Server Error: Cannot add Role",
        "error"
      );
      queryClient.invalidateQueries("GetRolesWithUsers");
    }
    resetAdd();
  }
  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="z-50 overflow-y-auto fixed inset-0  h-screen  bg-gray-500 bg-opacity-75 transition-opacity opacity-100"
          onClose={() => {}}
        >
          <div className="">
            <div className="flex items-center justify-center py-10  ">
              <Dialog.Panel
                className={
                  isForAddingRole
                    ? " transform overflow-visible rounded-lg bg-white p-3 shadow-xl transition-all"
                    : "max-w-xxl h-1/2 transform overflow-visible rounded-lg bg-white p-3 shadow-xl transition-all"
                }
              >
                {isForAddingRole ? (
                  <></>
                ) : (
                  <>
                    <ReactTooltip
                      id="closeIcon"
                      place="right"
                      type="light"
                      effect="solid"
                    />
                    <button
                      data-tip="Close"
                      data-for="closeIcon"
                      data-class="text-xxs whitespace-pre px-0"
                      onClick={onClose}
                      className={`absolute z-50 -right-2 -top-2`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        className="w-7 h-7 text-octonary cursor-pointer"
                      >
                        <path
                          fillRule="evenodd"
                          d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </button>
                  </>
                )}{" "}
                <Dialog.Title className="pb-2">
                  <div className="flex font-bold text-primary text-md">
                    <div>{isForAddingRole ? "Add Role" : "USERS DETAILS"}</div>
                    <div>
                      {/* <EditButton
                        onClick={() => {
                          setIsEditUser(true);
                          handleEdit(...userData);
                        }}
                        disabled={isEditUser}
                        className={
                          isEditUser
                            ? "opacity-50 rounded-full items-center bg-quaternary hover:bg-tertiary text-white hover:bg-hquaternary "
                            : "opacity-100 rounded-full items-center bg-quaternary hover:bg-tertiary text-white hover:bg-hquaternary"
                        }
                        buttonText="Edit"
                      /> */}
                    </div>
                  </div>
                  <div className="w-full border-b-2 border-secondary my-1" />
                  <div className="italic text-gray-600 ">{roleName}</div>
                </Dialog.Title>
                {isForAddingRole ? (
                  <>
                    {" "}
                    <div className="flex">
                      {" "}
                      <span className="">Role Name:</span>
                      <TextInput
                        value={undefined}
                        disabled={saveModal}
                        className={saveModal ? "opacity-50" : "opacity-100"}
                        onChange={(e) => {
                          const data = roleData;
                          setRoleData({
                            ...data,
                            roleName: e.target.value,
                            updatedBy: userAccount.userName,
                          });
                        }}
                        // defaultValue={rowData?.roleName}
                      />
                    </div>
                    <div className="flex justify-end items-center gap-2 mt-5 ">
                      {saveModal ? (
                        <ConfirmBoxNoLabel
                          onClick={() => handleSave()}
                          onCLose={() => setSaveModal(false)}
                        />
                      ) : (
                        <>
                          <div>
                            <SaveButton
                              className={"opacity-100 "}
                              disabled={false}
                              buttonText="Save"
                              onClick={() => {
                                setSaveModal(true);
                              }}
                            />
                          </div>
                          <div>
                            <CancelButton
                              disabled={false}
                              buttonText="Cancel"
                              type={undefined}
                              onClick={() => {
                                HandleCancel();
                              }}
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </>
                ) : (
                  <div className="text-xs h-full">
                    <MaterialTableTS
                      data={userData}
                      isLoading={false}
                      columns={agencyColumns}
                      headerStyle={{
                        color: "#6495ED",
                        fontWeight: "bold",
                        fontSize: "12px",
                        whiteSpace: "nowrap",
                      }}
                      toolbarSearch={true}
                      showToolbar={true}
                    />
                  </div>
                )}
              </Dialog.Panel>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default RoleUsersViewModal;
